import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  Divider,
  IconButton,
  Box,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useMainContext } from "../../../../../../context/useMainContext";

export default ({
  open,
  setOpen,
  handleAddPartner,
  profileUrl,
  setProfileUrl,
  skippedProfiles = [],
}) => {
  const { loadingData } = useMainContext();
  const handleClose = () => setOpen(false);
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Add Profile
        <IconButton onClick={handleClose} size="small" aria-label="Close dialog">
          <CloseOutlinedIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Type the profile URL of the influencer
        </Typography>

        <TextField
          fullWidth
          size="small"
          variant="outlined"
          id="profile-url"
          label="Profile URL"
          value={profileUrl}
          onChange={(e) => setProfileUrl(e.target.value)}
          sx={{ mb: 3 }}
        />

        <Button
          fullWidth
          variant="contained"
          onClick={() => handleAddPartner(profileUrl)}
          disableElevation
          size="large"
          sx={{ mb: 2 }}
          loading={loadingData}
        >
          Add Profile
        </Button>

        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Divider sx={{ flexGrow: 1 }} />
          <Typography sx={{ mx: 2 }}>OR</Typography>
          <Divider sx={{ flexGrow: 1 }} />
        </Box>

        <Button
          component="label"
          fullWidth
          variant="contained"
          disableElevation
          size="large"
          loading={loadingData}
        >
          Upload CSV
          <input type="file" hidden accept=".csv" onChange={handleAddPartner} />
        </Button>

        {skippedProfiles.length > 0 && (
          <>
            <Divider sx={{ my: 3 }} />
            <Typography variant="subtitle2" sx={{ mb: 2, color: "error.main" }}>
              Not Imported ({skippedProfiles.length})
            </Typography>
            <Box sx={{ maxHeight: 200, overflowY: "auto" }}>
              {skippedProfiles.map((profile, index) => (
                <Box
                  key={index}
                  sx={{
                    mb: 1,
                    px: 2,
                    py: 1,
                    bgcolor: "error.lighter",
                    borderRadius: 1,
                    border: 1,
                    borderColor: "error.light",
                  }}
                >
                  <Typography fontWeight="bold" variant="body2">
                    @{profile.username} ({profile.platform})
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {profile.link}
                  </Typography>
                </Box>
              ))}
            </Box>
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button variant="outlined" onClick={handleClose} disableElevation>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
